<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    :title="isAgree ? '同意/同意保留' : '同意'"
  >
    <template v-slot:body="{ cancel }">
      <v-card-text class="pa-0">
        <div class="x-scroll-hide">
          <v-container>
            <v-row>
              <v-col>
                <div class="font-weight-bold">
                  {{ agreementItem.agreementTitle }}
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <div
                  class="scroll_area pa-1 ma-1"
                  ref="agree"
                  @scroll="checkScrollArea"
                >
                  <span>{{ agreementText }}</span>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-center mt-2">
                同意者 {{ agreeUserName }}
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-checkbox
                v-model="accepted"
                :disabled="!isScrollDown"
                density="compact"
                label="上記の内容に同意します。"
                hide-details
              ></v-checkbox>
            </v-row>
          </v-container>
        </div>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn
              color="primary"
              variant="flat"
              :disabled="!accepted"
              @click="agree"
            >
              同意
            </v-btn>
            <template v-if="agreementItem.agreementStatus === null">
              <v-btn
                color="primary"
                variant="flat"
                :disabled="accepted"
                @click="hold"
              >
                同意保留
              </v-btn>
            </template>
            <v-btn variant="outlined" color="primary" @click="cancel">
              キャンセル
            </v-btn>
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { AgreementInfoList } from "@/apis/AgreementApi";
import { VueFinalModal } from "vue-final-modal";

export default defineComponent({
  name: "AgreeStatusChangeConfirm",
  props: {
    /** 同意情報 */
    agreementItem: {
      type: Object as PropType<AgreementInfoList>,
      required: true,
    },
    /** 同意排他情報 */
    agreementKeyId: {
      type: String as PropType<string>,
      required: true,
    },
    /** 同意内容情報 */
    agreementText: {
      type: String as PropType<string>,
      required: true,
    },
  },
  data() {
    return {
      accepted: false,
      isScrollDown: false,
    };
  },
  computed: {
    agreeUserName(): string {
      return this.$store.state.user.me?.familyName
        ? this.$store.state.user.me?.familyName +
            this.$store.state.user.me?.givenName
        : "";
    },
    isAgree(): boolean {
      return this.agreementItem.agreementStatus === null;
    },
  },
  async mounted() {
    /**
     * nextTickではDOM構造が更新されたことを保証されるが、
     * DOMレンダリングが完了することが保証されるわけではなく、高さが取得出来ない。
     * そのため、setTimeoutを利用してDOMレンダリングが完了後にスクロールチェックを実施する。
     */
    setTimeout(() => {
      this.checkScrollArea();
    });
  },
  methods: {
    /**
     * 同意内容が最後まで表示された場合に同意するチェックボックスを押下可能にする
     */
    checkScrollArea() {
      const element = this.$refs.agree as HTMLElement;
      // 最下部までスクロールしたかの判定
      if (
        element.scrollHeight - (element.clientHeight + element.scrollTop) <
        1
      ) {
        this.isScrollDown = true;
      }
    },
    /** 同意 */
    async agree() {
      await this.$api.agreement.postAgreement(this.agreementItem.agreementSeq, {
        agreementKeyId: this.agreementKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    /** 同意保留 */
    async hold() {
      await this.$api.agreement.postAgreementHold(
        this.agreementItem.agreementSeq,
        {
          agreementKeyId: this.agreementKeyId,
        }
      );
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>

<style scoped lang="scss">
.x-scroll-hide {
  overflow-x: hidden;
  max-height: 70vh;
}
.scroll_area {
  height: 400px;
  border: solid #ced4da;
  border-radius: 5px;
  overflow-y: scroll;
  white-space: pre-wrap;
  line-height: 1.5;
}
</style>
